import { render, staticRenderFns } from "./rect-item.vue?vue&type=template&id=3e9a1a7e&"
import script from "./rect-item.vue?vue&type=script&lang=js&"
export * from "./rect-item.vue?vue&type=script&lang=js&"
import style0 from "./rect-item.vue?vue&type=style&index=0&id=3e9a1a7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports